import { Users, CheckCircle2, Layers, CreditCard } from "lucide-react";
import { fmtCurrency } from "./clientConstants";

function StatCard({ testId, icon: Icon, iconBg, label, caption, value }) {
  return (
    <div data-testid={testId} className="relative overflow-hidden rounded-[14px] border border-[#E4E9F0] bg-white px-5 py-4 flex items-center gap-4 min-w-0" style={{ boxShadow: "0 3px 12px rgba(15,23,42,0.035)" }}>
      <div className="h-10 w-10 shrink-0 rounded-full grid place-items-center" style={{ backgroundColor: iconBg }}><Icon size={18} strokeWidth={1.75} className="text-[#0C2347]" /></div>
      <div className="min-w-0">
        <div className="text-[12px] text-[#475467]">{label}</div>
        <div className="text-xl sm:text-[28px] lg:text-[32px] font-semibold text-[#101828] leading-tight truncate" title={String(value)}>{value}</div>
        {caption && <div className="text-[11px] text-[#94A3B8] mt-0.5">{caption}</div>}
      </div>
    </div>
  );
}

export function ClientStatCards({ stats }) {
  const s = stats || { total_clients: 0, active_clients: 0, total_orders: 0, outstanding_balance: 0 };
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      <StatCard testId="client-stat-total" icon={Users} iconBg="#E8F1FD" label="Total Clients" value={s.total_clients} />
      <StatCard testId="client-stat-active" icon={CheckCircle2} iconBg="#E5F7ED" label="Active Clients" value={s.active_clients} />
      <StatCard testId="client-stat-orders" icon={Layers} iconBg="#E8F1FD" label="Total Orders" caption="Across all orders" value={s.total_orders} />
      <StatCard testId="client-stat-balance" icon={CreditCard} iconBg="#F6EFE3" label="Outstanding Balance" caption="Across all orders" value={fmtCurrency(s.outstanding_balance)} />
    </div>
  );
}
